"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const resize_observer_1 = require("@juggle/resize-observer");
const ResizeObserver = (_a = window.ResizeObserver) !== null && _a !== void 0 ? _a : resize_observer_1.ResizeObserver;
const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
        entry.target.dispatchEvent(new CustomEvent("resize", {
            bubbles: false,
        }));
    }
});
const observer = resizeObserver.observe;
const unobserver = resizeObserver.unobserve;
resizeObserver.observe = function (target, options) {
    if (target) {
        observer.call(this, target, options);
    }
};
resizeObserver.unobserve = function (target) {
    if (target) {
        unobserver.call(this, target);
    }
};
exports.default = resizeObserver;
